/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { Modal } from "react-bootstrap";
import UserProfilePopOver from "./userProfilePopOver";
import { XIcon } from "../../assets/icons/svg";

const UserProfileModal = ({
  show,
  closeModal,
  userInfo,
  isOpenModal,
  selectedLanguage,
}) => {
  return (
    <Modal show={show} onHide={() => closeModal()}>
      <Modal.Header>
        <div
          className="icon-close top-10 cursor-pointer"
          onClick={() => closeModal()}
        >
          <XIcon width={15.556} height={15.556} />
        </div>
      </Modal.Header>
      <Modal.Body className="d-flex align-items-center justify-content-center">
        <UserProfilePopOver
          userInfo={userInfo}
          isOpenModal={isOpenModal}
          closeModal={closeModal}
          selectedLanguage={selectedLanguage}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UserProfileModal;
